import anime from 'animejs'

const moreInformation = document.getElementById('more-information');
const moreInformationContent = document.getElementById('footer');
const heightInitFooter = document.getElementById('height-footer');
const footerBottom = document.getElementById('footer-bottom');
const footerClose = document.getElementById('footer-close');
const footerHeader = document.getElementById('footer-header');


moreInformation.init = () => {
    moreInformationContent.style.bottom = -(moreInformationContent.offsetHeight) + "px";
    // footerBottom.style.paddingTop = (heightInitFooter.offsetHeight + 15) + "px";
};

const footerUp = document.querySelectorAll('.footer-up');
for (var i = 0, length = footerUp.length; i < length; i++) {
    footerUp[i].addEventListener('click', function(e) {
        if (!moreInformationContent.classList.contains("active")) {
            anime({
                targets: moreInformationContent,
                bottom: 0,
                duration: 1400,
                loop: false,
                opacity: 1,
                easing: 'easeInOutQuart'
            });
            anime({
                targets: footerHeader,
                bottom: moreInformationContent.offsetHeight - 5,
                duration: 1400,
                loop: false,
                delay: 0,
                opacity: 1,
                easing: 'easeInOutQuart',
                complete: function() {
                    moreInformationContent.classList.add("active");
                    footerClose.classList.add("active");
                    footerUp.textContent = "Close";
                }
            });

        } else {
            anime({
                targets: moreInformationContent,
                bottom: -(moreInformationContent.offsetHeight),
                duration: 1400,
                loop: false,
                easing: 'easeInOutQuart'
            });
            anime({
                targets: footerHeader,
                bottom: 0,
                duration: 1400,
                loop: false,
                delay: 0,
                opacity: 1,
                easing: 'easeInOutQuart',
                complete: function() {
                    moreInformationContent.classList.remove("active");
                    footerClose.classList.remove("active");
                    // footerUp.textContent = "Item information";
                }
            });

        }
    })
}

// moreInformation.onclick = () => {
//     if (!moreInformationContent.classList.contains("active")) {
//         anime({
//             targets: moreInformationContent,
//             bottom: 0,
//             duration: 1400,
//             loop: false,
//             opacity: 1,
//             easing: 'easeInOutQuart'
//         });
//         anime({
//             targets: footerHeader,
//             bottom: moreInformationContent.offsetHeight - 5,
//             duration: 1400,
//             loop: false,
//             delay: 0,
//             opacity: 1,
//             easing: 'easeInOutQuart'
//         });


//         moreInformationContent.classList.add("active");
//         footerClose.classList.add("active");
//         moreInformation.textContent = "Close";
//     } else {
//         anime({
//             targets: moreInformationContent,
//             bottom: -(moreInformationContent.offsetHeight),
//             duration: 1400,
//             loop: false,
//             easing: 'easeInOutQuart'
//         });
//         anime({
//             targets: footerHeader,
//             bottom: 0,
//             duration: 1400,
//             loop: false,
//             delay: 0,
//             opacity: 1,
//             easing: 'easeInOutQuart'
//         });
//         moreInformationContent.classList.remove("active");
//         footerClose.classList.remove("active");
//         moreInformation.textContent = "Book information";
//     }
// };

footerClose.onclick = () => {
    if (moreInformationContent.classList.contains("active")) {
        anime({
            targets: moreInformationContent,
            bottom: -(moreInformationContent.offsetHeight),
            duration: 1400,
            loop: false,
            easing: 'easeInOutQuart'
        });
        anime({
            targets: footerHeader,
            bottom: 0,
            duration: 1400,
            loop: false,
            delay: 0,
            opacity: 1,
            easing: 'easeInOutQuart',
            complete: function() {
                moreInformationContent.classList.remove("active");
                footerClose.classList.remove("active");
                // moreInformation.textContent = "Item information";
            }
        });

    }
};

var resizeTimer;

window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        footerHeader.style.bottom = 0 + "px";
        moreInformationContent.style.bottom = -moreInformationContent.offsetHeight + "px";
        // footerBottom.style.paddingTop = (heightInitFooter.offsetHeight + 15) + "px";
    }, 250);
});
export { moreInformation, footerClose };